import { BASE_YEAR } from "configurations/Constants";

export const DateHelper = {
  getYears: () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= BASE_YEAR; year--) {
      years.push(year);
    }
    return years;
  },
};
